// Product Form Fix
// This script fixes the ADD TO CART button not responding issue

console.log('=== Product Form Fix Script Loaded ===');

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFix);
} else {
  initFix();
}

function initFix() {
  console.log('Initializing product form fix...');
  
  // Critical Fix: Patch the product-form handleSubmit method to handle undefined formVariants
  patchProductFormHandleSubmit();
  
  // Find all product forms
  const productForms = document.querySelectorAll('product-form');
  
  if (productForms.length === 0) {
    console.warn('No product-form elements found!');
    return;
  }
  
  productForms.forEach((productFormElement, index) => {
    console.log(`Fixing product form ${index}...`);
    
    const form = productFormElement.querySelector('form');
    const submitButton = productFormElement.querySelector('[type="submit"]');
    const variantIdInput = productFormElement.querySelector('[name="id"]');
    
    if (!form) {
      console.error(`Product form ${index}: No form element found`);
      return;
    }
    
    if (!submitButton) {
      console.error(`Product form ${index}: No submit button found`);
      return;
    }
    
    // Fix 1: Ensure variant ID input is enabled
    if (variantIdInput && variantIdInput.disabled) {
      console.log(`Product form ${index}: Enabling variant ID input`);
      variantIdInput.disabled = false;
    }
    
    // Fix 2: Remove aria-disabled if button is not actually disabled
    if (submitButton.getAttribute('aria-disabled') === 'true' && !submitButton.disabled) {
      console.log(`Product form ${index}: Removing aria-disabled from submit button`);
      submitButton.removeAttribute('aria-disabled');
    }
    
    // Fix 3: Add a backup submit handler
    submitButton.addEventListener('click', function(e) {
      console.log(`Product form ${index}: Submit button clicked`);
      
      // Check if button is disabled
      if (this.disabled || this.getAttribute('aria-disabled') === 'true') {
        console.log(`Product form ${index}: Button is disabled, preventing submit`);
        e.preventDefault();
        return;
      }
      
      // If the form's submit event is not being triggered, manually trigger it
      setTimeout(() => {
        if (!form.submitting) {
          console.log(`Product form ${index}: Manually triggering form submit`);
          form.submitting = true;
          
          // Create and dispatch a submit event
          const submitEvent = new Event('submit', {
            bubbles: true,
            cancelable: true
          });
          form.dispatchEvent(submitEvent);
        }
      }, 10);
    });
    
    // Fix 4: Ensure form submit handler is working
    form.addEventListener('submit', function(e) {
      console.log(`Product form ${index}: Form submit event triggered`);
      form.submitting = false;
    }, true);
    
    console.log(`Product form ${index}: Fix applied successfully`);
  });
  
  console.log('Product form fix initialization complete');
}

// Patch the product-form custom element to fix the formVariants.length error
function patchProductFormHandleSubmit() {
  console.log('Patching product-form handleSubmit method...');
  
  const productForms = document.querySelectorAll('product-form');
  
  productForms.forEach((productFormElement, index) => {
    // Fix the quantityBreaks element if it exists but doesn't have formVariants
    if (productFormElement.quantityBreaks && !productFormElement.quantityBreaks.formVariants) {
      console.log(`Product form ${index}: Adding missing formVariants array to quantityBreaks`);
      productFormElement.quantityBreaks.formVariants = [];
    }
    
    // Fix the bundleDeals element if it exists but doesn't have formVariants
    if (productFormElement.bundleDeals && !productFormElement.bundleDeals.formVariants) {
      console.log(`Product form ${index}: Adding missing formVariants array to bundleDeals`);
      productFormElement.bundleDeals.formVariants = [];
    }
    
    // Fix the quantityGifts element if it exists but doesn't have unlockedItems
    if (productFormElement.quantityGifts && !productFormElement.quantityGifts.unlockedItems) {
      console.log(`Product form ${index}: Adding missing unlockedItems array to quantityGifts`);
      productFormElement.quantityGifts.unlockedItems = [];
    }
    
    console.log(`Product form ${index}: Patched successfully`);
  });
  
  console.log('Product-form handleSubmit patch complete');
}

// Also check if the custom element is properly defined
if (!customElements.get('product-form')) {
  console.error('CRITICAL: product-form custom element is not defined!');
  console.log('This means the custom element definition in global.js failed to load or execute.');
} else {
  console.log('product-form custom element is properly defined');
}
